module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-4-2.874479b0.png";